export const requestTemplate = {
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    type: '',
    description: '',
    indicators: '',
    entryConditions: '',
    entryConfirmation: '',
    exitConditions: '',
    trailingStop: '',
    spreadManagement: '',
    tradeVolume: '',
    maxLossModel: '',
    lotSizeCalculation: '',
    drawdownManagement: '',
    manualTrading: '',
    multiTradeManagement: '',
    tradingTimeRestrictions: '',
    adminPanelRequired: false,
    notificationSystem: false,
}